import { CheckNotes, InspectionCase } from '../inspection-cases';

export class AerosolInstallationDto extends InspectionCase {
  item_10_1?: InspectionCase;
  item_10_2?: InspectionCase;
  item_10_3?: InspectionCase;
  item_10_4?: InspectionCase;
  item_10_5?: InspectionCase;
  item_10_6?: InspectionCase;
  item_10_7?: InspectionCase;
  item_10_8?: InspectionCase;
  item_10_9?: InspectionCase;
  item_10_10?: InspectionCase;
  item_10_11?: InspectionCase;
  item_10_12?: InspectionCase;
  item_10_13?: InspectionCase;
}

export class AerosolInstallation extends AerosolInstallationDto {
  constructor(
    data: AerosolInstallationDto = {
      title:
        'התקנת אירוסול באזורים שאינם מאוכלסים בד"כ (חדר השנאה של חברת חשמל)'
    }
  ) {
    super(data);
    this.item_10_1 = new InspectionCase({
      ...data.item_10_1,
      title: `קיים מתג לניתוק המערכת בכניסה לאזור או מחוץ לחלל המוגן. המתג יוגן מפני הפעלה בשוגג`
    });
    this.item_10_2 = new InspectionCase({
      ...data.item_10_2,
      title: `בהפעלת המתג מתקבל תקלה ברכזת`
    });
    this.item_10_3 = new InspectionCase({
      ...data.item_10_3,
      title: `קיים שרטוט קבוע ובר קיימא ועמיד למים שיכלול תרשים האתר המוגן, מיקום המחולל, דרכי יציאה, מתג לניתוק המערכת`
    });
    this.item_10_4 = new InspectionCase({
      ...data.item_10_4,
      title: `הדלתות מאפשרות פתיחה מבפנים גם כשהם נעולים מבחוץ`
    });
    this.item_10_5 = new InspectionCase({
      ...data.item_10_5,
      title: `קיים צופר פינוי בחדר + שלט "הופעל כיבוי" מחוץ לחדר + צופר גילוי`
    });
    this.item_10_6 = new InspectionCase({
      ...data.item_10_6,
      title: `הפעלת הכיבוי לאחר השהייה שבין 30-60 שניות`
    });
    this.item_10_7 = new InspectionCase({
      ...data.item_10_7,
      title: `קיימים הוראות לסילוק מחולל הכיבוי מהחלל לפני ביצוע עבודה בחום באזור המוגן`
    });
    this.item_10_8 = new InspectionCase({
      ...data.item_10_8,
      title: `קיים אמצעי אוורור בחדר אחרי פריקה של הכיבוי `
    });
    this.item_10_9 = new InspectionCase({
      ...data.item_10_9,
      title: `קיים שילוט אזהרה בכניסה לחלל לפי ציור 8.1 שבתקן`
    });
    this.item_10_10 = new InspectionCase({
      ...data.item_10_10,
      title: `קיים שילוט אזהרה בתוך לחלל לפי ציור 8.2 שבתקן`
    });
    this.item_10_11 = new InspectionCase({
      ...data.item_10_11,
      title: `קיים שילוט למפסק ניטרול לפי ציור 8.3 שבתקן`
    });
    this.item_10_12 = new InspectionCase({
      ...data.item_10_12,
      title: `קיים שילוט ליד מפסק הכיבוי לפי ציור 8.4 שבתקן`
    });
    this.item_10_13 = new InspectionCase({
      ...data.item_10_13,
      title: `התקנת המחולל בחלל  בוצעה בהתאם להוראות יצרן הציוד`
    });
  }

  setInspectionStatus(): void {
    this.isPassed =
      !this.isApplicable ||
      ((!this.item_10_1.isApplicable || this.item_10_1.isPassed) &&
        (!this.item_10_2.isApplicable || this.item_10_2.isPassed) &&
        (!this.item_10_3.isApplicable || this.item_10_3.isPassed) &&
        (!this.item_10_4.isApplicable || this.item_10_4.isPassed) &&
        (!this.item_10_5.isApplicable || this.item_10_5.isPassed) &&
        (!this.item_10_6.isApplicable || this.item_10_6.isPassed) &&
        (!this.item_10_6.isApplicable || this.item_10_7.isPassed) &&
        (!this.item_10_6.isApplicable || this.item_10_8.isPassed) &&
        (!this.item_10_6.isApplicable || this.item_10_9.isPassed) &&
        (!this.item_10_6.isApplicable || this.item_10_10.isPassed) &&
        (!this.item_10_6.isApplicable || this.item_10_11.isPassed) &&
        (!this.item_10_6.isApplicable || this.item_10_12.isPassed) &&
        (!this.item_10_6.isApplicable || this.item_10_13.isPassed));
  }

  getNotes?(): CheckNotes[] {
    if (!this.isApplicable) {
      return [];
    }
    return [
      ...this.item_10_1.getNotes(),
      ...this.item_10_2.getNotes(),
      ...this.item_10_3.getNotes(),
      ...this.item_10_4.getNotes(),
      ...this.item_10_5.getNotes(),
      ...this.item_10_6.getNotes(),
      ...this.item_10_7.getNotes(),
      ...this.item_10_8.getNotes(),
      ...this.item_10_9.getNotes(),
      ...this.item_10_10.getNotes(),
      ...this.item_10_11.getNotes(),
      ...this.item_10_12.getNotes(),
      ...this.item_10_13.getNotes()
    ];
  }
}
